import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaChartLine, FaArrowRight } from 'react-icons/fa';

const ProductLauncher = () => {
  const { t } = useTranslation();
  return (
    <motion.a
      href="/dnevni-list/"
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, x: 30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.1, duration: 0.55 }}
      whileHover={{ x: -4 }}
      className="product-launcher"
      aria-label={t('product.title')}
      title={t('product.title')}
    >
      <span className="product-launcher-icon"><FaChartLine /></span>
      <span className="product-launcher-copy">
        <small>{t('product.eyebrow')}</small>
        <strong>{t('product.title')}</strong>
        <em>{t('product.subtitle')} <FaArrowRight /></em>
      </span>
    </motion.a>
  );
};

export default ProductLauncher;
